import React from 'react';
import { Link } from 'react-router-dom';
// import Quote from './Quote';

const routeCards = [
  {
    title: 'Spouse Visa',
    path: '/services/partner-and-family-visa/spouse-visa',
  },
  {
    title: 'Civil Partner Visa',
    path: '/services/partner-and-family-visa/civil-partner-visa',
  },
  {
    title: 'Unmarried Partner Visa',
    path: '/services/partner-and-family-visa/unmarried-partner-visa',
  },
  {
    title: 'Fiancé Visa',
    path: '/services/partner-and-family-visa/fiance-visa',
  },
  {
    title: 'Proposed Civil Partner Visa',
    path: '/services/partner-and-family-visa/proposed-civil-partner-visa',
  },
  {
    title: 'Child Visas',
    path: '/services/partner-and-family-visa/child-visas',
  },
  {
    title: 'Parent of a Child Visa',
    path: '/services/partner-and-family-visa/parent-of-a-child-visa',
  },
  {
    title: 'Adult Dependent Relative Visa',
    path: '/services/partner-and-family-visa/adult-dependent-relative-visa',
  },
];

const processSteps = [
  'Review your circumstances and identify the correct application route.',
  'Prepare a tailored evidence checklist and explain what each document must prove.',
  'Draft representations and assemble the application bundle.',
  'Submit the application and support you through Home Office queries or next steps.',
];

const PartnerFamilyVisa = () => {
  return (
    <div className="bg-white pt-20">
      <section className="relative overflow-hidden bg-[rgb(26,36,58)] py-8 text-white lg:pt-20">
        <div className="container relative mx-auto px-4">
          <div className="max-w-3xl">
            <div className="mb-6 flex items-center gap-3 text-sm font-semibold text-[#C9A04A]">
              <Link to="/" className="hover:text-white">Home</Link>
              <span>/</span>
              <Link to="/#services" className="hover:text-white">Services</Link>
              <span>/</span>
              <span>Immigration Law</span>
            </div>
            <h1 className="mb-6 text-4xl font-bold leading-tight lg:text-6xl">
              Partner and Family Visa
            </h1>
            <p className="max-w-2xl text-base leading-8 text-white/85 lg:text-lg">
              Practical immigration advice for families who need to live together
              in the UK. We help clients prepare strong, well-evidenced
              applications with clear guidance from first review to submission.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#contact"
                className="inline-flex items-center justify-center bg-[#C9A04A] px-6 py-3 font-bold text-[rgb(26,36,58)] hover:bg-white"
              >
                Get advice
              </a>
              <a
                href="tel:+4401216306635"
                className="inline-flex items-center justify-center border border-white/40 px-6 py-3 font-bold text-white hover:border-yellow hover:text-[#C9A04A]"
              >
                Call +44 (0) 121 630 6635
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-light-grey py-8">
        <div className="container mx-auto px-4">
          <div className="grid gap-6 md:grid-cols-3">
            {routeCards.map((card) => (
              <Link
                key={card.title}
                to={card.path}
                className="rounded-lg bg-white p-8 shadow-panel transition-transform duration-200 hover:-translate-y-1 hover:shadow-lg"
              >
                <h3 className="text-center text-xl font-bold text-purple-600">{card.title}</h3>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="py-8">
        <div className="container mx-auto px-4">
          <div className="grid gap-12 lg:grid-cols-2 lg:items-start">
            <div>
              <h2 className="mb-6 text-3xl font-bold text-[rgb(26,36,58)]">
                Our process
              </h2>
              <p className="leading-8 text-gray-700">
                We keep the application process structured and transparent, so
                you know what is needed, why it matters, and what happens next.
              </p>
            </div>
            <ol className="space-y-5">
              {processSteps.map((step, index) => (
                <li key={step} className="flex gap-4">
                  <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center bg-purple font-bold text-white">
                    {index + 1}
                  </span>
                  <p className="pt-1 leading-7 text-gray-700">{step}</p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </section>

      {/* <Quote /> */}
    </div>
  );
};

export default PartnerFamilyVisa;
